<!-- components/MultiCurrencyCard.vue -->
<template>
    <section class="flex justify-center items-center">
        <div class="relative w-full max-w-[380px] max-h-[240px]">
            <!-- Main Card -->
            <div
                class="relative w-full h-full rounded-2xl border border-[var(--background-btn)] bg-[var(--background-primary)] p-4 shadow-md">
                <h2 class="text-lg font-semibold text-[var(--text-secondary)] mb-3">
                    Select Preferred Currency
                </h2>

                <div class="grid grid-cols-2 gap-4">
                    <!-- Currency option -->
                    <div v-for="option in currencies" :key="option.code"
                        class="flex items-center gap-3 px-2 py-4 bg-[#FAFAFA0A] rounded-md cursor-pointer"
                        @click="selected = option.code">
                        <span class="text-lg font-bold text-[var(--text-secondary)]">{{ option.symbol }}</span>
                        <p class="text-xs font-medium text-[var(--text-secondary)] flex-1">
                            {{ option.label }}
                        </p>
                        <!-- Radio style -->
                        <div class="w-5 h-5 rounded-full border-2 flex items-center justify-center transition" :class="selected === option.code
                            ? 'border-[var(--text-secondary)]'
                            : 'border-gray-400'">
                            <div v-if="selected === option.code"
                                class="w-3 h-3 bg-[var(--text-secondary)] rounded-full"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">

const selected = ref("eur");

const currencies = [
    { code: "usd", symbol: "$", label: "USD (US Dollar)" },
    { code: "eur", symbol: "€", label: "EUR (Euro)" },
    { code: "gbp", symbol: "£", label: "GBP (British Pound)" },
    { code: "inr", symbol: "₹", label: "INR (Indian Rupee)" },
];
</script>
